import { css } from '@adornis/chemistry/directives/css';
import { html } from 'lit';
import { Folder } from '../../db/Folder';
import { LASFile } from '../../db/LASFile';
import type { MediaUnion } from '../../db/MediaUnion';
import { SupportedFileType } from '../las-file-explorer';
import { getMediaIcon } from './getMediaIcon';

export const getMediaPreview = (media: MediaUnion) => {
  const color = getColorByMedia(media);
  return html`
    <d-flex
      center
      crossaxis-center
      ${css({
        aspectRatio: '1 / 1',
        borderRadius: '8px',
        backgroundColor: getLighterColor(color),
        margin: '16px',
        marginBottom: '8px',
        position: 'relative',
        overflow: 'hidden',
      })}
    >
      ${media instanceof LASFile && media.meta?.mimetype.startsWith('image')
        ? html`
            <img
              src=${LASFile.getServeLink(media._id)}
              style="z-index: 2; position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover;"
            />
          `
        : html`
            <d-icon
              solid
              ${css({
                fontSize: '3rem',
                color,
                zIndex: 1,
              })}
            >
              ${getMediaIcon(media)}
            </d-icon>
          `}
    </d-flex>
  `;
};

export function getColorByMedia(media: MediaUnion) {
  if (media instanceof Folder) {
    return '#64D2FF';
  }

  const extension = media.meta?.extension;
  switch (extension as SupportedFileType) {
    case SupportedFileType.PDF:
      return '#e74c3c';
    case SupportedFileType.JPG:
    case SupportedFileType.JPNG:
    case SupportedFileType.PNG:
    case SupportedFileType.WEBP:
    case SupportedFileType.GIF:
      return '#3498db';
    case SupportedFileType.MP3:
      return '#9b59b6';
    case SupportedFileType.MP4:
      return '#2ecc71';
    default:
      return '#f39c12'; // Auffällige orange Farbe, die noch nicht verwendet wurde
  }
}

/**
 * Berechnet eine blassere Version der übergebenen Farbe
 * @param color Hex-Farbcode (z.B. #3498db)
 * @param opacity Opazität zwischen 0 und 1 (Standard: 0.1)
 * @returns Blassere Farbe als Hex-Code oder rgba-Wert
 */
export function getLighterColor(color: string, opacity: number = 0.1): string {
  // Hex zu RGB konvertieren
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // RGBA-Wert mit Transparenz zurückgeben
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}
